import axios from 'axios';

import PlanSeleccionar from '../types/PlanSeleccionar';


async function GuardarPlanesPrestador(prmIdPrestador: number, prmPlanesPrestador: PlanSeleccionar[]) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_planes_prestador"
    
    // Transformo prmPlanesPrestador a un objeto que tenga "id": y el valor pero solo los ids

    const planesIds = prmPlanesPrestador.map(item => ({id: item.id}));

    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_prestador": prmIdPrestador,
            "planes": planesIds
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarPlanesPrestador;